const Types = {
 SET_TAB_VALUE: 'SET_TAB_VALUE',
};
export default Types;
